import { render, staticRenderFns } from "./IntelligenceFunnelChart.vue?vue&type=template&id=70a5e37e&scoped=true"
import script from "./IntelligenceFunnelChart.vue?vue&type=script&lang=js"
export * from "./IntelligenceFunnelChart.vue?vue&type=script&lang=js"
import style0 from "./IntelligenceFunnelChart.vue?vue&type=style&index=0&id=70a5e37e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a5e37e",
  null
  
)

export default component.exports